import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isNumeric } from 'dpl/shared/form/utils';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import { PAGE } from 'dpl/constants/query_params';

export default function useSearchQueryFilter(queryParamName) {
  const queryParams = useSelector(state => state.queryParams);

  const dispatch = useDispatch();

  const searchQueryFilterValues = useMemo(
    () =>
      (queryParams[queryParamName] || '')
        .split(',')
        .filter(isNumeric)
        .map(Number),
    [queryParams[queryParamName]]
  );

  function toggleFilter(filterValue) {
    const newFilterIds = new Set(searchQueryFilterValues);

    newFilterIds.has(filterValue)
      ? newFilterIds.delete(filterValue)
      : newFilterIds.add(filterValue);

    if (newFilterIds.size > 0) {
      dispatch(
        pushParams(
          {
            [queryParamName]: [...newFilterIds].join(',')
          },
          { hash: true }
        )
      );
    } else {
      dispatch(resetParams(queryParamName, { hash: true }));
    }

    dispatch(resetParams(PAGE));

    return newFilterIds;
  }

  return {
    searchQueryFilterValues,
    toggleFilter
  };
}
